export default class AxTable {
  table: HTMLTableElement;

  constructor(table: HTMLTableElement){
    this.table = table;
  }

  init() {
      const rows = this.table.getElementsByTagName('tr');
      let cols;

      if (rows) {
        Array.from(rows).forEach((row) => {
          if (row.children) {
            cols = row.children;
            Array.from(cols).forEach((col) => {
              const div = this.createDiv(this.table.offsetHeight);
              this.setListeners(div, this.table);
              col.appendChild(div);
            });
          }
        });
      }
  }

  createDiv(height: number) {
    const div = document.createElement('div');
    div.className = 'ax-table--col-resize';
    return div;
  }

  setListeners(div: HTMLElement, table: HTMLElement) {
    let pageX: number | null = null;
    let curCell: HTMLElement | null = null;
    let curCellWidth: number | null = null;
    let tableWidth: number;
    let padding: number;
    let resizableCol: HTMLElement | null = null;

    document.addEventListener('mousedown', function (e) {
      tableWidth = table.offsetWidth;

      if (e.target instanceof HTMLDivElement && e.target.parentElement) {
        curCell = (e.target as HTMLDivElement).parentElement;
        if (curCell && curCell.attributes) {
          resizableCol = curCell;
        }
        pageX = e.pageX;
        if (curCell) {
          if (
            window
              .getComputedStyle(curCell, null)
              .getPropertyValue('box-sizing') === 'border-box'
          ) {
            padding = 0;
          }
          const padLeft = window
            .getComputedStyle(curCell, null)
            .getPropertyValue('padding-left');
          const padRight = window
            .getComputedStyle(curCell, null)
            .getPropertyValue('padding-right');
          padding = parseInt(padLeft, 10) + parseInt(padRight, 10);
          curCellWidth = curCell.offsetWidth - padding;
        }
      }
    });

    document.addEventListener('mousemove', function (e) {
      let cell: HTMLTableCellElement | null = null;
      if (curCell && curCell.getAttribute('data-resize')!="none") {
        cell = (e.target as HTMLDivElement).parentNode as HTMLTableCellElement;
        if (cell && cell.cellIndex >= 0) {
          const cellNo = cell.cellIndex;
          curCell = table.getElementsByTagName('th')[cellNo]; // Now curCell is the header of the targeted column
        }
        const diffX = e.pageX - (pageX === null ? 0 : pageX);

        curCell.style.width =
          (curCellWidth === null ? 0 : curCellWidth) + diffX + 'px';
        table.style.width = tableWidth + diffX + 'px';

        // Keep the width (min-width and max-width) of columns with the fixed width the same. (dont change the width)
        const noneReCols = document.querySelectorAll(
          `[data-resize="none"]`
        ) as NodeList;

        if (noneReCols && noneReCols?.length > 0) {
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let i = 0; i < noneReCols.length; i++) {
            const noneReCol = noneReCols[i] as HTMLTableColElement;
            if (noneReCol.nodeName === 'TH') {
              noneReCol.style.width = '0px';
            }
          }
        }
      }
    });

    document.addEventListener('mouseup', function (e) {
      curCell = null;
      pageX = null;
      curCellWidth = null;
      resizableCol = null;
    });

    div.addEventListener('mouseover', function (e) {
      curCell = null;
      pageX = null;
      curCellWidth = null;
      resizableCol = null;

      const resizableDivs = getResizableDivs(e);

      resizableDivs.forEach((resizableDiv) => {
        resizableDiv.style.borderRight = '2px solid #FF9533';
      });
    });

    div.addEventListener('mouseout', function (e) {
      const resizableDivs = getResizableDivs(e);
      resizableDivs.forEach((resizableDiv) => {
        resizableDiv.style.borderRight = '';
      });
    });

    const getResizableDivs = function (e: MouseEvent) {
      const resizableDivs = [];
      const tableHeader = document.querySelector(
        '.ax-table--header-sticky'
      ) as HTMLTableRowElement;
      const contentSections = document.querySelectorAll('.ax-table--content, .ax-accordion-content');
      const tableSubfooters = document.querySelectorAll('.ax-table--subfooter');
      const tableFooter = document.querySelector('.ax-table--footer');

      let targetCellIndex = 0;

      const resizeDiv = e.target as HTMLDivElement; // Resize div element
      const cellToResize = resizeDiv.closest('td, th'); // Table cell
      const cellRow = cellToResize?.closest('tr'); // Table row

      if (cellToResize instanceof HTMLTableCellElement) {
        targetCellIndex = cellToResize.cellIndex;
      }

      let offsetColSpan = 0;

      const getColSpanOffset = (tableRowObject: HTMLTableRowElement) => {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < tableRowObject.cells.length; i++) {
          const cellColSpan = tableRowObject.cells[i].getAttribute('colspan');
          if (typeof cellColSpan === 'string') {
            {
              offsetColSpan += parseInt(cellColSpan, 10);
            }
          }
          if (!cellColSpan) {
            offsetColSpan += 1;
          }
          if (e.target && tableRowObject.cells[i] === e.target) {
            break;
          }
        }
        return offsetColSpan - 1;
      };

      const elementBody =
        // eslint-disable-next-line id-blacklist
        cellRow === null || cellRow === undefined
          ? null
          : cellRow.parentElement; // Look for thead or tbody that is parent of the table row
      const rowsWithColspans = ['ax-table--subfooter', 'ax-table--footer'];

      if (elementBody) {
        rowsWithColspans.forEach((rowWithColSpans) => {
          if (elementBody.classList.contains(rowWithColSpans)) {
            if (cellRow) {
              targetCellIndex = getColSpanOffset(cellRow);
            }
          }
        });
      }

      // Get resizable divs
      //   - selects which resizableDiv to change colour in order to construct the resize indicator line
      // Header
      resizableDivs.push(
        tableHeader?.cells[targetCellIndex].querySelector(
          '.ax-table--col-resize'
        )
      );
      // Table content
      contentSections.forEach((contentSection: any) => {
        contentSection.querySelectorAll("tr").forEach((row: any) => {
          resizableDivs.push(
            row.cells[targetCellIndex].querySelector('.ax-table--col-resize')
          );
        });
      });
      // Subfooters
      tableSubfooters.forEach((tableSubfooter) => {
        const row = tableSubfooter.querySelector('tr') as HTMLTableRowElement;
        let celloffset = 0;
        if (row) {
          Array.from(row.cells).forEach((cell) => {
            const cellColSpan = cell.getAttribute('colspan');
            if (typeof cellColSpan === 'string') {
              celloffset += parseInt(cellColSpan, 10);
            }
            if (typeof cellColSpan === 'object') {
              celloffset += 1;
            }
            if (celloffset === targetCellIndex + 1) {
              resizableDivs.push(cell.querySelector('.ax-table--col-resize'));
            }
          });
        }
      });
      // Footer
      const footerRow = tableFooter?.querySelector('tr');
      let footerCellOffset = 0;

      if (footerRow) {
        Array.from(footerRow.cells).forEach((cell) => {
          const cellColSpan = cell.getAttribute('colspan');
          if (typeof cellColSpan === 'string') {
            footerCellOffset += parseInt(cellColSpan, 10);
          }
          if (typeof cellColSpan === 'object') {
            footerCellOffset += 1;
          }
          if (footerCellOffset === targetCellIndex + 1) {
            resizableDivs.push(cell.querySelector('.ax-table--col-resize'));
          }
        });
      }
      return resizableDivs;
    };
  }
}
